import { ApiService } from "../../../config";
import { TCreateScenarioRes, TScenarioDelete, TScenarioRes } from "../models";
import { handleError } from "@/utils/parseApiReturn";

const getScenarios = async (
  page: number,
  accountId: number
): Promise<TScenarioRes> => {
  try {
    const res = await ApiService.get(`/accounts/${accountId}/scenarios`, {
      page,
      limit: "100"
    });
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para obter critérios:");
  }
};
const createScenario = async (
  name: string,
  prompt: string | null,
  accountId: number
): Promise<TCreateScenarioRes> => {
  try {
    const res = await ApiService.post(
      `/accounts/${accountId}/scenarios/create`,
      {
        name,
        prompt,
        accountId
      }
    );

    return res.data;
  } catch (error: unknown) {
    return handleError(error);
  }
};
const editScenario = async (
  name: string,
  prompt: string,
  accountId: number,
  scenarioId: number
): Promise<any> => {
  try {
    const res = await ApiService.patch(
      `/accounts/${accountId}/scenarios/${scenarioId}`,
      {
        name,
        prompt,
        accountId
      }
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(error);
  }
};
const deleteScenario = async (
  accountId: number,
  scenarioId: number
): Promise<TScenarioDelete> => {
  try {
    const res = await ApiService.delete(
      `/accounts/${accountId}/scenarios/${scenarioId}`
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para excluir critério:");
  }
};
const setCurrentScenario = async (
  accountId: number,
  scenarioId: number,
  userId: number
): Promise<any> => {
  try {
    const res = await ApiService.post(
      `accounts/${accountId}/scenarios/${scenarioId}/set-current-scenario`,
      { userId }
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro inesperado ao definir critério atual:");
  }
};
const getScenario = async (
  accountId: number,
  scenarioId: number
): Promise<TScenarioRes> => {
  try {
    const res = await ApiService.get(
      `/accounts/${accountId}/scenarios/${scenarioId}`
    );
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para obter critério:");
  }
};
export const ScenariosService = {
  getScenarios,
  getScenario,
  createScenario,
  editScenario,
  deleteScenario,
  setCurrentScenario
};
